
import { Component, Vue } from 'vue-property-decorator';
import { LogModule } from '~/store/modules/log';
import { humanReadableDate } from '~common-filters/humanReadableDate';

@Component({
    filters: {
        humanReadableDate,
    },
})
export default class LogList extends Vue {


    get headers() {
        return [
            { text: 'Method', value: 'method', align: 'left' },
            { text: 'Action', value: 'action' },
            { text: 'Params', value: 'params' },
            { text: 'Initiator', value: 'initiator' },
            { text: 'Additional Logs', value: 'additional_logs' },
            { text: 'Previous', value: 'previous' },
            { text: 'Date', value: 'date' },
        ];
    }

    get logsDisplayed() {
        return LogModule.logsDisplayed;
    }
}
